import { BaseCongratulationPopup } from './BaseCongratulationPopup';
import { webConfig } from '../../../core/applicationConfig';

export class CongratulationsWebPopup extends BaseCongratulationPopup {
  execute({ root }) {
    const container = this.getPopup({
      scale: 1.75,
      parentWidth: webConfig.width,
      parentHeight: webConfig.height,
      mistakeY: -90
    });
    root.addChild(container);
  }
}
